module.exports = __webpack_public_path__ + "img/facebook-4.2758072.jpeg";